
import euPolitics from '../data/euPolitics5.json';
import parties from '../data/parties.json';

export const countryPartiesFunc = (country) => parties.filter(x => x.country === country)[0].parties.filter(x => !(x.filtered ?? false));
export const politicsFunc = (country) => euPolitics.find(x => x.country === country);
